var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.216 47.516L46.784 42.936L42.676 38.816L40.362 41.13L38.946 39.716L41.25 37.4L37.346 33.496L32.766 38.076L42.216 47.516ZM57.884 63.196L62.464 58.616L58.562 54.712L56.246 57.016L54.83 55.6L57.134 53.284L53.054 49.216L48.484 53.784L57.884 63.196ZM38.306 64H32V57.692L40.788 48.904L30 38.076L37.346 30.73L48.224 41.57L57.158 32.624C57.378 32.4026 57.61 32.2433 57.854 32.146C58.098 32.0486 58.358 32 58.634 32C58.9113 32 59.1713 32.0486 59.414 32.146C59.6567 32.2433 59.8893 32.4026 60.112 32.624L63.376 36.016C63.5973 36.236 63.7507 36.468 63.836 36.712C63.92 36.9546 63.962 37.2146 63.962 37.492C63.962 37.7693 63.9193 38.0213 63.834 38.248C63.75 38.4746 63.5973 38.6986 63.376 38.92L54.52 47.826L65.27 58.654L57.924 66L47.096 55.212L38.306 64ZM34 62H37.454L57.094 42.374L53.626 38.908L34 58.548V62ZM55.384 40.626L53.626 38.908L57.092 42.374L55.384 40.626Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.00f09541c1c998e5d489c2e1a1709034.svg";
export { ForwardRef as ReactComponent };